import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const TalentSection = () => {
  const { t } = useLanguage();

  const benefits = [
    {
      icon: "Shield",
      title: t('talent.stayAnonymous'),
      description: t('talent.stayAnonymousDesc')
    },
    {
      icon: "TrendingUp",
      title: t('talent.premiumRoles'),
      description: t('talent.premiumRolesDesc')
    },
    {
      icon: "Users",
      title: t('talent.directContact'),
      description: t('talent.directContactDesc')
    },
    {
      icon: "CheckCircle",
      title: t('talent.youDecide'),
      description: t('talent.youDecideDesc')
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-xl border border-white/20 shadow-lg rounded-full mb-4 md:mb-6">
              <Icon name="Briefcase" size={20} color="#0025cc" />
              <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('talent.badge')}</span>
            </div>
            
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4 md:mb-6">
              {t('talent.title')}
            </h2>
            
            <p className="text-base md:text-lg text-[#6B7280] mb-8 md:mb-10 leading-relaxed">
              {t('talent.subtitle')}
            </p>
            
            <div className="space-y-4 md:space-y-6 mb-8 md:mb-10">
              {benefits?.map((benefit, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-[#0025cc]/10 flex items-center justify-center">
                      <Icon name={benefit?.icon} size={20} color="#0025cc" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-base md:text-lg font-semibold text-[#111827] mb-1">
                      {benefit?.title}
                    </h3>
                    <p className="text-sm md:text-base text-[#6B7280]">
                      {benefit?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            
            <Button 
              variant="default" 
              size="lg"
              onClick={() => window.location.href = '/access-request'}
              iconName="ArrowRight"
              iconPosition="right"
              className="w-full sm:w-auto"
            >
              {t('talent.requestTalentAccess')}
            </Button>
          </div>
          
          <div className="relative">
            <div className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-3xl p-6 md:p-8 shadow-xl" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.2) 100%)'
            }}>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center">
                  <Icon name="User" size={24} color="#FFFFFF" />
                </div>
                <div>
                  <div className="h-3 bg-[#E5E7EB] rounded w-32 mb-2"></div>
                  <div className="h-2 bg-[#E5E7EB] rounded w-24"></div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="bg-[#F6F7FB] rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="Briefcase" size={16} color="#6B7280" />
                    <div className="h-2 bg-[#E5E7EB] rounded w-24"></div>
                  </div>
                  <div className="h-3 bg-[#E5E7EB] rounded w-full mb-2"></div>
                  <div className="h-3 bg-[#E5E7EB] rounded w-3/4"></div>
                </div>
                
                <div className="bg-[#F6F7FB] rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="Award" size={16} color="#6B7280" />
                    <div className="h-2 bg-[#E5E7EB] rounded w-32"></div>
                  </div>
                  <div className="h-3 bg-[#E5E7EB] rounded w-full mb-2"></div>
                  <div className="h-3 bg-[#E5E7EB] rounded w-2/3"></div>
                </div>

                <div className="bg-[#0025cc]/10 rounded-xl p-4 border-2 border-[#0025cc]">
                  <div className="flex items-center justify-between">
                    <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('talent.identityProtected')}</span>
                    <Icon name="ShieldCheck" size={20} color="#0025cc" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalentSection;